import axios from 'axios';
import QS    from 'qs';
// import baseURLs from '@/utils/url.config.js';
const baseURLs = require('@/utils/url.config.js');

// Online
axios.defaults.baseURL = baseURLs.server_api_url;
// Loc
// axios.defaults.baseURL = baseURLs.server_api_url_loc;

/**
 * post方法，对应post请求
 * @param {String}  url    [请求的url地址]
 * @param {Object}  params [请求时携带的参数]
 * @param {Boolean} json   [true：JSON格式请求头；false：FormData格式请求头；]
 */
export const axios_post = function(url, params = {}, json = true){
	// JSON格式请求头
	const headerJSON = {
		"Content-Type": "application/json"
	};

	// FormData格式请求头
	const headerFormData = {
		"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
	};

	return new Promise((resolve, reject) => {
		axios
		.post(url, json ? JSON.stringify(params) : QS.stringify(params), {
			headers: json ? headerJSON : headerFormData
		})
		.then(res => {
			// console.log('=== request__axios_post__then_res >>>', res);
			resolve(res.data);
		})
		.catch(err => {
            // console.log('=== request__axios_post__catch_res >>>', err);
			reject(err.data);
		});
	});
}
